// extracted by mini-css-extract-plugin
export default {"input-root":"Input_input-root__sqBVQ","input-wrapper":"Input_input-wrapper__s7v+C"};